<template>
    <section class="uk-grid uk-grid-collapse" uk-grid="uk-grid">
        <main class="uk-width-1-1">
            <AppHeader />
            <AppMain />
            <AppFooter />
        </main>
    </section>

    <!-- This is a button toggling the off-canvas -->

    <div class="uk-position-fixed uk-position-bottom-right uk-overlay uk-background-secondary uk-dark uk-overlay-primary">
        <button uk-toggle="target: #offcanvas-basket" class="uk-button uk-button-primary uk-input-rounded" type="button">OPEN BASKET</button>
    </div>

    <!-- This is the off-canvas -->
    <div id="offcanvas-basket" uk-offcanvas="flip: true; overlay: true;">
        <div class="uk-offcanvas-bar uk-width-1-1 uk-width-large@m uk-padding-remove">
            <AppSidebar />

            <button class="uk-offcanvas-close" type="button" uk-close></button>

        </div>
    </div>

</template>

<script>
import AppHeader from "./components/app/Header";
import AppFooter from "./components/app/Footer";
import AppMain from "./components/app/Main";
import AppSidebar from "./components/app/Sidebar";
import AppCart from "./components/app/Cart";

export default {
    components: {
        AppHeader,
        AppFooter,
        AppMain,
        AppSidebar,
        AppCart
    },
    data() {
        return {
            //
        }
    }
};
</script>

<style></style>
